import React, {useEffect} from 'react';
import {AnnotationContainer, Controller, PerfWatchLog, V3DApp} from './components'
import {useSelector} from "react-redux";
import ContentSelector from "./redux/reducers/contents/action";
import 'bootstrap/dist/css/bootstrap.min.css';
import './app.css';


const App: React.FC = () => {

    const wind = useSelector(ContentSelector.getWind);

    useEffect(() => {
        try {
            // @ts-ignore
            window.v3d.puzzles.procedures.setRotate(wind);
        } catch (e) {

        }

    }, [wind]);

    const imgSrc = './preloader_logo.svg?' + Math.round(Math.random() * 1000000);


    return (
        <div className='app'>
            <V3DApp/>
            <Controller/>
            <PerfWatchLog/>
            <AnnotationContainer/>
            <div id='preloader_div' className='preloader-div'>
                <img src={imgSrc} alt=""/>
            </div>
        </div>
    );
}

export default App;
